import script from "./WatchHome.vue?vue&type=script&setup=true&lang=ts"
export * from "./WatchHome.vue?vue&type=script&setup=true&lang=ts"

import "./WatchHome.vue?vue&type=style&index=0&id=7ca33f9a&scoped=true&lang=stylus"

import exportComponent from "D:\\project\\web\\vysa_wifi_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ca33f9a"]])

export default __exports__